import {graphql} from 'gatsby'
import React from 'react'

import type {FeatureGridSliceFragment, FeatureGridFragment} from '@/graphql-types'
import TitleWithFeatures from '@/sections/title-with-features'
import {isValidBackgroundColor} from '@/utils/is-valid-background-color'

type Props = {
    slice: FeatureGridSliceFragment | FeatureGridFragment
    dataTestId?: string
}

export const FeatureGridSlice = React.forwardRef<HTMLDivElement, Props>(
    ({slice, dataTestId}, ref) => {
        const items = slice.items.map((feature) => ({
            title: feature.predefined_feature.document?.data.title ?? feature.feature_title,
            body:
                feature.predefined_feature.document?.data.body ??
                feature.feature_description.richText,
            image: feature.predefined_feature.document?.data.icon ?? feature.image,
        }))

        const color = isValidBackgroundColor(slice.primary.background)
            ? slice.primary.background
            : 'default'

        return (
            <TitleWithFeatures
                ref={ref}
                title={slice.primary.title}
                items={items}
                backgroundColor={color}
                dataTestId={dataTestId}
            />
        )
    }
)

export const featureGridSliceFragment = graphql`
    fragment FeatureGridSlice on PrismicSlicePageDataBodyFeatureGrid {
        __typename
        primary {
            title
            background
        }
        items {
            image {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
                gatsbyImageData(sizes: $threeColumns, breakpoints: $imageBreakpoints)
            }
            feature_title
            feature_description {
                richText
            }
            predefined_feature {
                document {
                    ... on PrismicFeatureIconCard {
                        data {
                            icon {
                                alt
                                copyright
                                url
                                dimensions {
                                    height
                                    width
                                }
                            }
                            title
                            body
                        }
                    }
                }
            }
        }
    }
`
